<template>
    <div>
        <v-dialog v-model="open" persistent max-width="600">
            <v-card>
                <v-toolbar :elevation="0" color="primary" dark>
                    <v-toolbar-title>Seleccionar fechas</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="$emit('close')">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text class="pt-6">
                    <v-card outlined>
                        <v-card-text>
                            <v-row>
                                <v-col cols="12" md="4" class="ma-auto">
                                    Selecciona un tipo
                                </v-col>
                                <v-col cols="12" md="8">
                                    <v-select
                                        v-model="type"
                                        outlined
                                        dense
                                        hide-details
                                        flat
                                        :items="[{
                                            text: '24 horas',
                                            value: 'hours'
                                        },{
                                            text: 'Rango de fechas',
                                            value: 'dates'
                                        }]"
                                    ></v-select>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                    <v-card outlined class="mt-3">
                        <v-card-text>
                            <v-row>
                                <v-col cols="12" md="4" class="ma-auto">
                                    Desde:
                                </v-col>
                                <v-col cols="12" md="8">
                                    <v-menu
                                        ref="start"
                                        v-model="start.open"
                                        :close-on-content-click="false"
                                        :return-value.sync="start.date"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="290px"
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field
                                                v-model="start.date"
                                                dense
                                                solo
                                                flat
                                                outlined
                                                hide-details
                                                prepend-inner-icon="mdi-calendar"
                                                v-bind="attrs"
                                                v-on="on"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker locale="es-es" v-model="start.date" no-title scrollable>
                                            <v-spacer></v-spacer>
                                            <v-btn text color="primary" @click="start.open = false">Cancel</v-btn>
                                            <v-btn text color="primary" @click="$refs.start.save(start.date)">OK</v-btn>
                                        </v-date-picker>
                                    </v-menu>
                                </v-col>
                                <v-col cols="12" offset-md="4" md="8" v-if="type == 'hours'">
                                    <v-text-field
                                        v-model="start.time"
                                        flat
                                        solo
                                        outlined
                                        dense
                                        type="time"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-divider v-if="type == 'dates'"></v-divider>
                            <v-row v-if="type == 'dates'">
                                <v-col cols="12" md="4" class="ma-auto">
                                    Hasta:
                                </v-col>
                                <v-col cols="12" md="8">
                                    <v-menu
                                        ref="end"
                                        v-model="end.open"
                                        :close-on-content-click="false"
                                        :return-value.sync="end.date"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="290px"
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field
                                                v-model="end.date"
                                                dense
                                                solo
                                                flat
                                                outlined
                                                hide-details
                                                prepend-inner-icon="mdi-calendar"
                                                v-bind="attrs"
                                                v-on="on"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker locale="es-es" v-model="end.date" no-title scrollable>
                                            <v-spacer></v-spacer>
                                            <v-btn text color="primary" @click="end.open = false">Cancel</v-btn>
                                            <v-btn text color="primary" @click="$refs.end.save(end.date)">OK</v-btn>
                                        </v-date-picker>
                                    </v-menu>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="blue-grey lighten-1"
                        dark
                        small
                        @click="$emit('close')"
                        >Cancelar</v-btn
                    >
                    <v-btn 
                        color="accent" 
                        small
                        @click="save"
                        >Guardar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-snackbar v-model="error.active" :timeout="3000">
            {{ error.message }}
            <template v-slot:action="{ attrs }">
                <v-btn
                    color="error"
                    text
                    v-bind="attrs"
                    @click="error.active = false"
                >
                    Cerrar
                </v-btn>
            </template>
        </v-snackbar>
    </div>
</template>

<script>
export default {
    name: 'datePicker',
    props: ['open'],
    data() {
        return {
            type: 'hours',
            error:{
                message: '',
                active: false,
            },
            start:{
                open: false,
                date: null, 
                time: '00:00:00'
            },
            end:{
                open: false,
                date: null,
                time: '00:00:00'
            }
        }
    },
    methods: {
        save(){
            let start, end, type
            if(this.type === 'hours'){

                if(this.start.date === null) return this.showError('Seleccione una fecha')
                start = this.formatDate(this.start.date, this.start.time)
                end = new Date(start.getTime() + 1000 * 60 * 60 * 24)
                type = 'hour'

            }else if(this.type === 'dates'){

                this.start.time = '00:00:00'
                this.end.time = '00:00:00'
                if(this.start.date === null || this.end.date === null) return this.showError('Seleccione las fechas')

                start = this.formatDate(this.start.date, this.start.time)
                end = this.formatDate(this.end.date, this.end.time)
                end = new Date(end.getTime() + 1000 * 60 * 60 * 24)
                if( start.getTime() > end.getTime() ) return this.showError('Fechas incorrectas')
                
                const DIFF = end.getTime() - start.getTime()
                const MOUNTH = 1000 * 60 * 60 * 24 * 31
                if(DIFF < MOUNTH) type = 'day'
                else type = 'month'
            }
            
            
            this.$emit('newValues', { start, end, type })
            this.$emit('close')
        },
        formatDate(str_date, str_time){
            let date = new Date()
            let [ year, month, day ] = str_date.split('-')
            date.setDate(day)
            date.setMonth(month - 1)
            date.setFullYear(year)
            if(str_time) date.setHours(...str_time.split(':'))
            return date
        },
        showError(message){
            this.error.message = message
            this.error.active = true
        }
    },
}
</script>